/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import Tables from "layouts/tables";
import Billing from "layouts/billing";
import RTL from "layouts/rtl";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import {
  Person,
  CheckBox,
  ReceiptLong,
  UploadFile,
  Payments,
  Inventory2Rounded,
  Stairs,
} from "@mui/icons-material";
import VendorPO from "layouts/view/VendorPO";
// @mui icons
import Icon from "@mui/material/Icon";
import { AuthProvider } from "context/AuthContext";
import VendorLedger from "layouts/view/VendorLedger";
import ASNUpload from "layouts/view/ASNUpload";
import VendorLedgerDetails from "layouts/view/VendorLedgerDetails";
import ASNStatus from "layouts/view/ASNStatus";
import AppointmentList from "layouts/view/AppointmentList";
import CommingSoon from "layouts/view/CommingSoon";
import GRNStatus from "layouts/view/GRNStatus";
import Staging from "layouts/view/Staging";
import ForgotPassword from "layouts/view/ForgotPassword";
import OTPVerification from "layouts/view/OTPVerification";
import ResetPassword from "layouts/view/ResetPassword";

const routes = [
  {
    name: "Forgot Password",
    key: "forgot-password",
    route: "/forgot-password",
    component: <ForgotPassword />,
  },
  {
    name: "OTP Verification",
    key: "otpverify",
    route: "/otpverify",
    component: <OTPVerification />,
  },
  {
    name: "Reset Password",
    key: "reset-password",
    route: "/reset-password",
    component: <ResetPassword />,
  },
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    icon: <Icon fontSize="small">dashboard</Icon>,
    route: "/dashboard",
    component: (
      <AuthProvider>
        <Dashboard />
      </AuthProvider>
    ),
  },
  {
    type: "collapse",
    name: "Vendor PO",
    key: "vendor-po",
    icon: <Person fontSize="small" />,
    route: "/vendor-po",
    component: (
      <AuthProvider>
        <VendorPO />
      </AuthProvider>
    ),
  },
  {
    type: "collapse",
    name: "PO/GRN Status",
    key: "grn-status",
    icon: <CheckBox fontSize="small" />,
    route: "/grn-status",
    component: <GRNStatus />,
  },
  // {
  //   type: "collapse",
  //   name: "Bill Status",
  //   key: "bill-status",
  //   icon: <ReceiptLong fontSize="small" />,
  //   route: "/tables",
  //   component: <CommingSoon />,
  // },
  {
    // type: "collapse",
    name: "ASN Upload",
    key: "asn-upload",
    icon: <UploadFile fontSize="small" />,
    route: "/asn-upload",
    component: (
      <AuthProvider>
        <ASNUpload />
      </AuthProvider>
    ),
  },
  {
    type: "collapse",
    name: "ASN Status",
    key: "asn-status",
    icon: <Inventory2Rounded fontSize="small" />,
    route: "/asn-status",
    component: (
      <AuthProvider>
        <ASNStatus />
      </AuthProvider>
    ),
  },
  {
    name: "Appointments",
    key: "appointment-list",
    route: "/appointments",
    component: (
      <AuthProvider>
        <AppointmentList />
      </AuthProvider>
    ),
  },
  {
    type: "collapse",
    name: "Vendor Ledger",
    key: "vendor-ledger",
    icon: <Payments fontSize="small" />,
    route: "/vendor-ledger",
    component: (
      <AuthProvider>
        <VendorLedger />
      </AuthProvider>
    ),
  },
  {
    name: "Vendor Ledger Details",
    key: "vendor-ledger-details",
    icon: <Payments fontSize="small" />,
    route: "/vendor-ledger-details",
    component: (
      <AuthProvider>
        <VendorLedgerDetails />
      </AuthProvider>
    ),
  },
  // {
  //   type: "collapse",
  //   name: "Tables",
  //   key: "tables",
  //   icon: <Icon fontSize="small">table_view</Icon>,
  //   route: "/tables",
  //   component: <Tables />,
  // },
  // {
  //   type: "collapse",
  //   name: "Billing",
  //   key: "billing",
  //   icon: <Icon fontSize="small">receipt_long</Icon>,
  //   route: "/billing",
  //   component: <Billing />,
  // },
  // {
  //   type: "collapse",
  //   name: "RTL",
  //   key: "rtl",
  //   icon: <Icon fontSize="small">format_textdirection_r_to_l</Icon>,
  //   route: "/rtl",
  //   component: <RTL />,
  // },
  // {
  //   type: "collapse",
  //   name: "Notifications",
  //   key: "notifications",
  //   icon: <Icon fontSize="small">notifications</Icon>,
  //   route: "/notifications",
  //   component: <Notifications />,
  // },
  // {
  //   type: "collapse",
  //   name: "Profile",
  //   key: "profile",
  //   icon: <Icon fontSize="small">person</Icon>,
  //   route: "/profile",
  //   component: <Profile />,
  // },
  {
    name: "Sign In",
    key: "sign-in",
    icon: <Icon fontSize="small">login</Icon>,
    route: "/login",
    component: <SignIn />,
  },
  {
    name: "Staging",
    key: "staging",
    icon: <Stairs fontSize="small" />,
    route: "/staging",
    component: (
      <AuthProvider>
        <Staging />
      </AuthProvider>
    ),
  },
  // {
  //   type: "collapse",
  //   name: "Sign Up",
  //   key: "sign-up",
  //   icon: <Icon fontSize="small">assignment</Icon>,
  //   route: "/authentication/sign-up",
  //   component: <SignUp />,
  // },
];

export default routes;
